module.exports = __webpack_public_path__ + "static/img/huan-zai-jin.8521d59.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/huan-zai-jin.jpeg
// module id = 1VFQ
// module chunks = 1